export default {
  restaurantbanner: {
    subtitle: "FOR RESTAURANTS",

    title1: "Order Smarter.",
    title2: "Spend Less.",

    desc:
      "MAHAL is a B2B food sourcing platform that helps restaurants connect with verified suppliers, manage orders, and control procurement , all from one place.",

    cta: "Start Ordering",
  },
};